export class NexsysMonitorStateModel {
	nexsysOrderLog?: NexsysOrder;
	nexsysOrderListFilters?: NexsysOrderListFilters;
	origin?: string;
}

export interface NexsysOrder {
	evoOrderId?: string;
	evoServiceId?: string;
	fncOrderId?: string;
	classOrderId?: string;
	created?: string;
	id?: string;
	nexsysOrderId?: string;
	valutrustOrderId?: string;
	xpanseSPNId: string;
	valuelinkOrderId?: string;
	transactionId?: string;
	updated?: string;
	valueLinkServiceId: string;
}

export interface NexsysOrderListFilters {
	transactionId: string;
	origin: string;
	provider: string;
	providerId: string;
	filenumber: string;
	orderId: string;
	limit: number;
	acuityId: string;
	isAddendum: boolean;
	xpanseLoanNumber: string;
}
